"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstateInsightsRequestSchema = exports.ESTATE_INSIGHT_STEPS = void 0;
const zod_1 = require("zod");
const estateRuby_1 = require("./estateRuby");
/** Ruby Estate "property insights" (spec 2026-10-15) — six data steps feeding the property Overview. */
exports.ESTATE_INSIGHT_STEPS = ['records', 'home_values', 'people', 'schools', 'safety', 'photo'];
exports.EstateInsightsRequestSchema = zod_1.z.object({
    propertyId: zod_1.z.string().trim().min(1).max(80),
    address: estateRuby_1.EstateRubyAddressSchema,
    kind: zod_1.z.enum(['residential', 'commercial', 'mixed']),
    geo: zod_1.z.object({ lat: zod_1.z.number().min(-90).max(90), lng: zod_1.z.number().min(-180).max(180) }).optional(),
    /** Cache only: no charge, no vendor call. The Overview peeks on open. */
    peek: zod_1.z.boolean().default(false),
});
//# sourceMappingURL=estateInsights.js.map